import React from 'react';
import { ViewEventListContainer } from './styled';
import ViewGroupItemsNew from '../ViewGroupItemsNew';
import { NoEventsMessageBlue } from '../../components/NoEventsMessage';

const ViewEventListNew = ({
    listStyle = 'splitter',
    isFirstGroupOpened = 'yes',
    events,
    danmarkItems,
    tournamentId,
    limit,
    showFavorites,
}) => {
    const isItFirstGroupOpened = isFirstGroupOpened
        ? isFirstGroupOpened
        : 'yes';

    return (
        <ViewEventListContainer>
            {Object.keys(events).length > 0 ? (
                [...Object.values(events)]
                    .sort((a, b) => {
                        if (a.priority && b.priority) {
                            return a.priority - b.priority;
                        }
                        return 0;
                    })
                    .map((sportEvents) => (
                        <ViewGroupItemsNew
                            danmarkItems={danmarkItems}
                            key={sportEvents.id}
                            data={events[sportEvents.id]}
                            listType={listStyle}
                            isFirstGroupOpened={isItFirstGroupOpened}
                            tournament={tournamentId}
                            limit={limit}
                            showFavorites={showFavorites}
                        />
                    ))
            ) : (
                <NoEventsMessageBlue />
            )}
        </ViewEventListContainer>
    );
};

export default ViewEventListNew;
